var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckSync({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.555664,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#047857"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18333 11.3111L4.25 8.58773L5.27667 7.63454L7.18333 9.40475L12.0233 4.91113L13.05 5.86432L7.18333 11.3111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckSync);
export default __webpack_public_path__ + "static/media/success_check_sync.88797c6ff088204602a61dc9d93ac240.svg";
export { ForwardRef as ReactComponent };